import * as types from "../mutation-types";
import {resetStoreState} from "@/store/storeUtils";

const defaultState = {
	activeTabs: {},
};

const state = {
	...defaultState
};

const getters = {
	activeTabs: state => state.activeTabs,
};

const actions = {
	setActiveTab({commit}, payload) {
		commit(types.SET_SESSION_ACTIVE_TAB, payload);
	},
};

const mutations = {
	[types.SET_SESSION_ACTIVE_TAB](state, { tabGroup, activeTab }) {
		// assign active tab to tab group name
		let obj = {};
		obj[tabGroup] = activeTab;

		// update state
		state.activeTabs = {
			...state.activeTabs,
			...obj
		};
	},

	initState(state) {
		resetStoreState(state, defaultState);
	}
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
};